import { Paper, Grid, Typography, Button } from "@material-ui/core";
import { IconCalendar, IconMapPin, IconNote } from "@tabler/icons-react";
import { useTheme } from "@material-ui/core/styles";
import { useState } from "react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import CostoDetalle from "./CostoDetalle";
import { Cost } from "../../../interfaces/costs/costs.interface";
import { IconListCheck } from "@tabler/icons-react";
import CostoNotas from "./CostoNotas";
import { visiblesCodes } from "../constants/constants";

interface props {
  cost: Cost;
}

const PriceItem = (props: { price: string; cents: string }) => {
  const theme = useTheme();

  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      <Typography
        color="primary"
        style={{
          fontSize: 32,
          fontWeight: 800,
          fontFamily: "monospace",
          display: "unset",
        }}
      >
        {props.price}
      </Typography>
      <span
        style={{
          fontSize: 16,
          fontWeight: 800,
          fontFamily: "monospace",
          position: "absolute",
          top: 6,
          color: theme.palette.primary.main,
        }}
      >
        {" "}
        {props.cents.length === 1 ? null : "." + props.cents}
      </span>
    </div>
  );
};

const CostoItem = ({ cost }: props) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showNotes, setShowNotes] = useState(false);

  const theme = useTheme();

  const charges = cost.charges.filter((charge) =>
    visiblesCodes.includes(charge.code)
  );

  // const base_rate = charges
  //   .map((ch) => Number(ch.base_rate))
  //   .reduce((a, b) => a + b, 0)
  //   .toFixed(2);

  // const per_unit = charges
  //   .map((ch) => Number(ch.per_unit))
  //   .reduce((a, b) => a + b, 0)
  //   .toFixed(2);

  const _total = (
    charges.map((ch) => Number(ch.per_unit)).reduce((a, b) => a + b, 0) +
    charges.map((ch) => Number(ch.base_rate)).reduce((a, b) => a + b, 0)
  ).toFixed(2);

  return (
    <div style={{ height: "100%" }}>
      <Paper
        elevation={4}
        style={{
          height: "100%",
        }}
      >
        <Grid container>
          <Grid
            item
            container
            xs={12}
            spacing={2}
            style={{ padding: 20, minHeight: 144 }}
          >
            <Grid item xs={10} sm={12} md={12}>
              <span>Naviero</span>
              <Typography
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                  marginBottom: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {cost.provider}
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12} sm={12} md={12}>
              <Grid item xs={12} sm={12} md={6}>
                <span>Contenedor</span> <br />
                <strong>{cost.container}</strong>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <span>Vía</span> <br />
                <strong>{cost.via}</strong>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <span>Comm. Code</span> <br />
                <strong>{cost.commodity}</strong> <br />
                <strong>({cost.commodity_description})</strong>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <span>T. Frequency</span> <br />
                <strong>
                  {cost.frequency === "\n" ? "-" : cost.frequency}
                </strong>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <span>Contract</span> <br />
                <strong>{cost.regla?.contract_number}</strong>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr color="whitesmoke" />
          </Grid>
          <Grid item container spacing={2} style={{ padding: "10px 20px" }}>
            <Grid item xs={12} sm={12} md={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconCalendar color={theme.palette.primary.main} />{" "}
                &nbsp;&nbsp;&nbsp;
                <div>
                  <small>Válido Desde</small> <br />
                  <strong>{cost.valid_from || "-"}</strong>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconCalendar color={theme.palette.primary.main} />{" "}
                &nbsp;&nbsp;&nbsp;
                <div>
                  <small>Válido Hasta</small> <br />
                  <strong>{cost.valid_to || "-"}</strong>
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr color="whitesmoke" />
          </Grid>
          <Grid
            item
            container
            style={{ margin: 5, justifyContent: "center", minHeight: 230 }}
          >
            <Grid item xs={6} style={{ textAlign: "center" }}>
              <div>
                <IconMapPin color={theme.palette.secondary.main} />
              </div>
              <span>
                <small>Origen</small>
                <br />
                {cost.origin === "UNDEFINED" ? "" : cost.origin}
              </span>
            </Grid>
            <Grid item xs={12}>
              <div style={{ marginTop: 5 }}>
                <div
                  style={{
                    margin: "0 auto",
                    border: "1px dashed",
                    width: 1,
                    height: 60,
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "center", marginTop: 5 }}>
              <div>
                <IconMapPin color={theme.palette.secondary.main} />
              </div>
              <span>
                <small>Destino</small>
                <br />
                {cost.destination === "UNDEFINED" ? "" : cost.destination}
              </span>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr color="whitesmoke" />
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            spacing={2}
            style={{ padding: "20px 20px" }}
          >
            {/* <Grid item xs={6}>
              <span>Base Rate</span>
              <PriceItem
                price={base_rate.substring(0, base_rate.indexOf("."))}
                cents={base_rate.substring(
                  base_rate.indexOf(".") + 1,
                  base_rate.length
                )}
                
              />
            </Grid> */}
            <Grid item xs={6} style={{ textAlign: "center" }}>
              <span>Total</span>
              <PriceItem
                price={_total.substring(0, _total.indexOf("."))}
                cents={_total.substring(_total.indexOf(".") + 1, _total.length)}
                // price={per_unit.substring(0, per_unit.indexOf("."))}
                // cents={per_unit.substring(
                //   per_unit.indexOf(".") + 1,
                //   per_unit.length
                // )}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr color="whitesmoke" />
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            spacing={2}
            style={{ padding: "20px 0px" }}
          >
            <Grid item>
              <Button
                startIcon={<IconNote />}
                variant="contained"
                onClick={() => setShowNotes(true)}
              >
                Notas
              </Button>
            </Grid>
            <Grid item>
              <Button
                startIcon={<IconListCheck />}
                variant="contained"
                onClick={() => setShowDetails(true)}
              >
                Detalles
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      {showDetails && (
        <CustomDialog
          isOpen={showDetails}
          handleClose={() => setShowDetails(false)}
          title="Detalles"
          hideActionButtons={true}
          maxWidth="md"
        >
          <CostoDetalle cost={cost} />
        </CustomDialog>
      )}
      {showNotes && (
        <CustomDialog
          handleClose={() => setShowNotes(false)}
          isOpen={showNotes}
          title="Notas"
          hideActionButtons
        >
          <CostoNotas costo={cost} />
        </CustomDialog>
      )}
    </div>
  );
};

export default CostoItem;
